

export default class mobileImageOrder
{
    constructor(_, Modernizr) {
        this.$sections = $('.section-reorder-mobile-js');

        if (!this.$sections.length) {
            return null;
        }

        this._ = _;
        this.Modernizr = Modernizr;
        this.mobileView = false;

        $(window).resize(this._.debounce(() => {
            this._checkWindowWidth();
        }, 500));

        this._checkWindowWidth();
    }

    _checkWindowWidth () {
        if (this.Modernizr.mq('(min-width: 900px)') && this.mobileView) {
            this._doReorder();
        } else if (!this.Modernizr.mq('(min-width: 900px)') && !this.mobileView) {
            this._doReorder();
        }
    }

    _doReorder() {
        this.$sections.each(function () {
            if (!$(this).find('.row').length || $(this).find('.row').children().length !== 2) {
                return true; // if section isn't a picture-text two-column layout, then skip
            }

            let $container = $(this).find('.row');
            let $first = $($container.children()[0]);
            let $second = $($container.children()[1]);

            if ($first.hasClass('left-pic-picture') && $second.hasClass('left-pic-text')) {
                return true; // if picture-text two-column layout already has the image first, skip
            }

            // first will be text, needs to be second
            // second will be image, needs to be first

            $first.appendTo($container); // appendTo() appends things as the last child.  So this is the text that is now 2nd.
        });

        this.mobileView = !this.mobileView;
    }
}
